module.exports = __webpack_public_path__ + "img/vue-press-logo.d1fed5cb.png";